module.exports = __webpack_public_path__ + "img/c7cdf09.png";